Ext.define('SA.VectorMapZoomRange', {
    constructor(min, max) {
        this.max = max;
        this.min = min;
    },

    getMaximum() {
        return this.max;
    },

    getMinimum() {
        return this.min;
    }
});